import {
	Component,
	EventEmitter,
	forwardRef,
	Input,
	OnInit,
	Output
} from '@angular/core';
import { Product } from '@models/models';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
	selector: 'addons-table',
	template: require('./addons-table.component.html'),
	styles: [require('./addons-table.component.scss')],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => AddonsTableComponent),
			multi: true
		}
	]
})
export class AddonsTableComponent implements OnInit, ControlValueAccessor {
	@Input() addons: Product[];
	@Input() quoteStatus: string;
	@Input() fromQuoteView?: boolean;
	@Output()
	updateNotSelectedAddon: EventEmitter<Product> = new EventEmitter<Product>();
	quantityDebouncer: Subject<Product> = new Subject<Product>();
	selectionDebouncer: Subject<null> = new Subject<null>();
	private propagateChange = Function.prototype;

	constructor() {}

	ngOnInit(): void {
		this.registerSelectionDebouncer();
		this.registerQuantityDebouncer();
	}

	changeAddonQuantity(addon: Product): void {
		if (
			addon.quantity !== null &&
			addon.quantity !== undefined &&
			addon.quantity >= 0
		) {
			this.quantityDebouncer.next(addon);
		}
	}

	preventNegativeInput(event, i) {
		const value = this.addons[i].quantity;
		if (value === null || value < 1) {
			event.preventDefault();
			this.addons[i].quantity = 1;
		}
	}

	preventDecimalInput(event, i) {
		const value = this.addons[i].quantity;
		if (value && value % 1 !== 0) {
			event.preventDefault();
			this.addons[i].quantity = Math.floor(value);
		}
	}

	changeAddonSelection(): void {
		this.selectionDebouncer.next();
	}

	writeValue(addons: Product[]): void {
		this.addons = addons;
	}

	registerOnChange(fn: Function): void {
		this.propagateChange = fn;
	}

	registerOnTouched() {}

	private registerQuantityDebouncer(): void {
		this.quantityDebouncer.debounceTime(500).subscribe((addon: Product) => {
			if (!addon.chosen) {
				this.updateNotSelectedAddon.emit(addon);
			} else {
				this.propagateChange(this.addons);
			}
		});
	}

	private registerSelectionDebouncer(): void {
		this.selectionDebouncer.debounceTime(500).subscribe(() => {
			this.propagateChange(this.addons);
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/quotes/addons-table/addons-table.component.ts